import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import "tom-select/dist/css/tom-select.css"

export default class extends Controller {
  static values = {
    createNewItems: Boolean,
    maxItems: { type: Number, default: null },
    options: { type: Array, default: [] },
    useAjax: Boolean
  }

  connect() {
    const config = {
      create: this.createNewItemsValue,
      createOnBlur: this.createNewItemsValue,
      maxItems: this.maxItemsValue,
      plugins: ['remove_button'],
      persist: false,
      delimiter: ',',
      searchField: ['value'],
      render: {
        option_create: (data, escape) => {
          return `<div class="create">Ajouter <strong>${escape(data.input)}</strong></div>`;
        },
        no_results: (data, escape) => {
          return `<div class="no-results">Aucun résultat trouvé pour "${escape(data.input)}"</div>`;
        },
        loading: () => {
          return '<div class="loading">Chargement...</div>';
        }
      }
    };

    if (this.useAjaxValue) {
      config.load = (query, callback) => {
        if (!query.length) return callback();

        fetch(`/users/searches?q=${encodeURIComponent(query)}`)
          .then(response => response.json())
          .then(json => callback(json))
          .catch(() => callback());
      };
    } else {
      config.options = this.optionsValue;
    }

    new TomSelect(this.element, config);
  }
}
